import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import { CandidateUpdateRequest } from './components/CandidateUpdateRequest';
import { CandidateUnsubscribe } from './components/CandidateUnsubscribe';
import SuccessPage from './components/SuccessPage';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Switch>
            <Route path='/Unsubscribe/:token' component={CandidateUnsubscribe} />
            <Route path='/UpdateCandidate/:token' component={CandidateUpdateRequest} />
            <Route path='/success/candidate-update' component={SuccessPage} />
        </Switch>
      </Layout>
    );
  }
}